import { Link, Text } from '@betterment/samba-react';

import urlBuilder from '../../../Shared/url-builder';

export function ReviewOrderDisclaimer() {
  return (
    <>
      <Text as="p" variant="text50" color="text.weak">
        This transaction won’t account for gains allowances and could cause your client to exceed their allowance
        target. Executed trades may result in realized gains/losses in your client’s account. Actual tax results will
        depend on your client’s specific circumstances, including their marginal tax rates and other transactions, both
        at Betterment and at other brokerages. This is not tax advice.
      </Text>

      <Text as="p" variant="text50" color="text.weak">
        <Link href={urlBuilder.getAdvisorInitiatedTransactionsArticle()} target="_blank" rel="noopener noreferrer">
          Learn more about advisor-initiated transactions.
        </Link>
      </Text>
    </>
  );
}
